import React from 'react';
import DocumentTitle from 'react-document-title';
import TopNavBar from 'containers/nav/TopNavBar';
import SubNavBar from 'containers/nav/SubNavBar';
import AdministrationSubNav from 'components/administration/AdministrationSubNav';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IoTriangle, IoSquare, IoEllipseSharp } from 'react-icons/io5';
import GroupList from './GroupList';
import SaveModal from './SaveModal';

const AdministrationOrganizationPage = () => {
  return (
    <DocumentTitle title='Sparkler - Administration'>
      <div style={{ minWidth: '1200px' }}>
        <TopNavBar />
        <SubNavBar />
        <AdministrationSubNav />
        <div className="row content">
          <div className="column">
            <div className="row">
              <div className="o-group-legend" style={{position: 'relative'}}>
                <a className='faq'href={window.ADMINISTRATION_YOUR_ORGANIZATION_FAQ_URL} target='_blank' rel="noreferrer" style={{position: 'absolute', right: 0, top: '8px'}}>
                  <i className='fa fa-question-circle' style={{ fontSize: 20, color: '#31ccff' }}></i>
                </a>
                <ul style={{display: 'flex', flexDirection: 'column', padding: '0'}}>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '0px'}}>
                    <IoSquare style={{marginRight: '2px', color: 'purple'}} />
                    <span style={{fontSize: '14px'}}>Group (Largest entity, e.g., a region or network)</span>
                  </li>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '16px'}}>
                    <IoTriangle style={{marginRight: '2px', color: 'green'}} />
                    <span style={{fontSize: '14px'}}>Subgroup (Middle-sized entity, e.g., a school or program)</span>
                  </li>
                  <li style={{display: 'flex', alignItems: 'center', paddingLeft: '32px'}}>
                    <IoEllipseSharp style={{marginRight: '2px', color: 'blue'}} />
                    <span style={{fontSize: '14px'}}>Cohort (Smallest entity that a child is part of, e.g., classroom, playgroup)</span>
                  </li>
                </ul>
              </div>
              <div className="o-group-list">
                <GroupList />
              </div>
              <SaveModal />
            </div>
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
}

AdministrationOrganizationPage.propTypes = {
  history: PropTypes.object.isRequired,
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
  onErrorMessage: PropTypes.func.isRequired,
  onCustomMessage: PropTypes.func.isRequired,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationOrganizationPage);
